module.exports = __webpack_public_path__ + "media/images/recruit/common/icon-close-b6be122ea2326a696d0e0c5c38637c2c.svg";